import React from 'react'
import { useTypewriter, Cursor } from "react-simple-typewriter";
import Media from './Media';

const LeftBanner = () => {
    const [text] = useTypewriter({
      words: ["Passionné d'informatique.", "Développeur Full-Stack.", "Dépanneur informatique."],
      loop: true,
      typeSpeed: 20,
      deleteSpeed: 10,
      delaySpeed: 2000,
    });
  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20">
      <div className="flex flex-col gap-5">
        <h4 className=" text-lg font-normal">Bienvenue sur mon site !</h4>
        <h1 className="text-6xl font-bold text-white">
          Je suis <span className="text-designColor capitalize">Arbeloa William</span>
        </h1>
        <h2 className="text-4xl font-bold text-white">
          un <span>{text}</span>
          <Cursor
            cursorBlinking="false"
            cursorStyle="|"
            cursorColor="#ff014f"
          />
        </h2>
        <p className="text-base font-bodyFont leading-6 tracking-wide">
        "J'ai créé une entreprise dans le domaine de l'informatique. Je peux vous conseiller sur les choix de composants pour vos PC, installer des systèmes d'exploitation type Windows, et bien plus encore..."
        </p>
      </div>
     {/* Media */}
     <Media />
    </div>
  );
}

export default LeftBanner